export default {info: 5 * 1000,success: 5 * 1000,warning: 5 * 1000,danger: 5 * 1000
}